import { createSlice } from "@reduxjs/toolkit";

import { initialState } from "./interface";

export const ShoppingSlice = createSlice({
  name: "shopping",
  initialState,
  reducers: {
    request: (state) => {
      state.isFetching = true;
      state.isError = false;
      state.fetchedShopping = false;
    },
    success: (state, action) => {
      state.isFetching = false;
      state.isError = false;
      state.shopping = action.payload;
      state.fetchedShopping = true;
    },
    error: (state) => {
      state.isFetching = false;
      state.isError = true;
      state.shopping = [];
      state.fetchedShopping = false;
    },
  },
});

export const { actions: ShoppingActions } = ShoppingSlice;

export default ShoppingSlice.reducer;
